import type { CSSProperties } from 'react';

export const portfolioModalHeaderClass =
  'shrink-0 flex justify-between gap-4 border-b border-slate-200 bg-white px-5 py-3.5';

export const portfolioModalTitleTextClass = 'text-base font-semibold leading-snug text-slate-950';

export const portfolioModalDescriptionClass = 'text-sm leading-snug text-slate-500';

export const portfolioModalCloseButtonClass =
  '-mr-1 shrink-0 rounded-md p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700';

export const portfolioModalBodyClass = 'min-h-0 flex-1 overflow-y-auto overscroll-contain px-5 py-4';

export const portfolioModalFooterClass =
  'shrink-0 flex flex-col-reverse gap-2 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-end';

export const portfolioModalShellClass = 'flex max-h-[min(85vh,720px)] flex-col';

export const portfolioModalContainerStyle: CSSProperties = {
  borderRadius: '12px',
  border: '1px solid rgba(15, 23, 42, 0.1)',
  boxShadow: '0 2px 8px -2px rgba(15, 23, 42, 0.12), 0 16px 40px -12px rgba(15, 23, 42, 0.28)',
  overflow: 'hidden',
  maxHeight: 'min(85vh, 720px)',
};
